import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const planetsportbetColors: ThemeTailwindType = {
    '--primary': '340 100% 46%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#010a26',
    secondary: '#ec004f',
    tertiary: '#0f71f2',
    dark: '#111111',
    shade1: '#1a223b',
    shade2: '#242c44',
    shade3: '#d9e3ec',
    shade4: '#e3eaf1',
    shade5: '#edf2f6',
    shade6: '#f8f9fb',
    textDark: '#111111',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.white,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#010a26',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#ec004f',
        buttonTxtColor: '#ffffff',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
